import { Injectable } from '@angular/core';
import { FormGroup} from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class MatriculaUtil {

    static extrairMatricula(form: FormGroup): string {
      let textsplit = form.controls['servidor'].value.split('-');
      return textsplit[0];
    }

  static extrairMatriculaString(dadosServidor: string): string {
    const começaComNúmero = /^\d/.test(dadosServidor);
    let matricula = [];
    if (começaComNúmero) {
      matricula = dadosServidor.split('-');
      return matricula[0];
    }
    return dadosServidor;
  }

}
